module.exports = __webpack_public_path__ + "img/logo.8293438c.png";